import { render } from "./EmailConnectionsIsStandard.vue?vue&type=template&id=243f97d0&scoped=true"
import script from "./EmailConnectionsIsStandard.vue?vue&type=script&lang=js"
export * from "./EmailConnectionsIsStandard.vue?vue&type=script&lang=js"

import "./EmailConnectionsIsStandard.vue?vue&type=style&index=0&id=243f97d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-243f97d0"]])

export default __exports__